import styled from 'styled-components';
import { DescribeTitle } from '../../../../components/Section/Describe/styles';

export const OfferInfo = styled(DescribeTitle)`
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #0669de;
  margin: 0;
  @media (max-width: 650px) {
    width: 195px;
    margin-left: 7px !important;
  }
`;
